<template>
  <div class="PopupField">
    <div class="instructionDivStyle">
      <div class="infoTopStyle">
        <span class="infoListLeft">
          担保金金额
          <span
            class="instructionsInfoStyles"
            @click="instructiionsClick"
          >缴存说明
          </span>
        </span>
        <span class="infoListRight marginAmount">
          {{dataInfo.value ? toThousands(dataInfo.value) : ''}}元
        </span>
      </div>
      <div class="infoBottomSytle">
        <span class="promptInfoStyle">确认签署前需缴存担保金到还款账号</span>
      </div>
    </div>

    <!-- 担保金缴存说明 -->
    <van-popup
      v-model="instructionsVisabld"
      closeable
      position="bottom"
      :style="{ height: '55%' }"
    >
      <InstructionsInfos />
    </van-popup>
  </div>
</template>
<script>
import { toThousands } from '@/utils/index';
import InstructionsInfos from './InstructionsInfos.vue';

export default {
  props: {
    dataInfo: {},
    pageData: {},
  },
  data() {
    return {
      instructionsVisabld: false,
    };
  },
  components: {
    InstructionsInfos,
  },
  created() {
  },
  computed: {
  },
  methods: {
    toThousands(e) {
      return toThousands(e);
    },
    instructiionsClick() {
      this.instructionsVisabld = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.PopupField {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 90%;
  height: 70px;
  margin: 0 auto;
  border-bottom: 1px solid #eee;
  .instructionDivStyle {
    width: 100%;
    text-align: left;
    .infoTopStyle {
      position: relative;
      top: -2px;
      .infoListLeft {
        color: rgba(56, 56, 56, 1);
        font-size: 14px;
        .instructionsInfoStyles {
          margin-left: 10px;
          color: #f65846;
        }
      }
      .infoListRight {
        color: rgba(128, 128, 128, 1);
        font-size: 14px;
        float: right;
      }
    }
    .infoBottomSytle {
      position: relative;
      top: 2px;
      .promptInfoStyle {
        font-family: PingFangSC-Regular;
        color: #9ea7b4;
        letter-spacing: 0;
        font-size: 12px;
      }
      .topUpBtn {
        float: right;
        width: 50px;
        height: 20px;
        background: #ff6538;
        color: #ffffff;
        line-height: 20px;
        text-align: center;
        font-size: 14px;
      }
    }
  }
}
</style>
